import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Header = ({ className, availabilityToggle }) => (
  <div className={className}>
    <span>Disponibilité pour recevoir</span>
    <CloseIcon
      onClick={availabilityToggle}
      style={{ color: 'hsl(0, 79%, 72%)' }}
    />
  </div>
);

Header.propTypes = {
  className: PropTypes.string.isRequired,
  availabilityToggle: PropTypes.func.isRequired,
};

export default styled(Header)`
  display: flex;
  justify-content: space-between;
  span {
    font-weight: bold;
    font-size: 1.2rem;
  }
`;
